export default __webpack_public_path__ + "static/media/theme-jungle.46a09a0b.png";